var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"width":_vm.width},scopedSlots:_vm._u([{key:"activator",fn:function({on}){return [_c('v-btn',_vm._g({attrs:{"tile":"","color":"success"}},on),[_c('v-icon',[_vm._v("mdi-plus")]),_vm._t("text")],2)]}}],null,true)},[_c('v-card',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }